<template lang="pug">
  .layout-hero
    navbar
    transition(name="", mode="out-in")
      router-view
    footer-standard
</template>

<script>
import Navbar from '@/components/structure/Navbar';
import FooterStandard from '@/components/structure/FooterStandard';

export default {
  name: 'LayoutTopper',
  components: {
    Navbar, FooterStandard,
  },
  data() {
    return {

    };
  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>
.layout-hero{
  display: flex;
  flex-direction: column;
  background-color: white;
  // padding-top: $navbar-height;
  position: relative;
  min-height: 100vh;
  .page {
    flex-grow: 1;
  }
  hr {
    border-top: 1px solid black ;
  }
}

  .page-enter-active, .page-leave-active {
    transition: transform 0.3s;
  }
  .page-enter {
    transform: translateY(100%);
  }

  // .page-enter-to {
  //   transform: translateX(0%);
  // }

  .page-leave-to {
    transform: translateY(100%);
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.1s;
  }
  .fade-enter {
    opacity: 1;
  }

  // .page-enter-to {
  //   transform: translateX(0%);
  // }

  .fade-leave-to {
    opacity: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/layout/LayoutHero.vue